module.exports = "<label *ngIf=\"showCaption\">\r\n    {{caption}}</label>\r\n\r\n    <textarea [disabled]=\"disabled\"  style=\"position: relative;\" [rows]=\"rows\" [placeholder]=\"placeholder\" type=\"text\" class=\"form-control \" [(ngModel)]=\"value\" (blur)=\"onBlur()\"  >\r\n    </textarea>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixstextarea/ixstextarea.component.html
// module id = 1054
// module chunks = 22